import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var msMaxWidth = 'max-width: 48rem';
  var mq = "@media only screen and (".concat(msMaxWidth, ")");
  return {
    categoriesWrapper: {
      paddingBottom: componentTheme.categoriesWrapperPadding,
      borderBottom: "".concat(componentTheme.borderWidth, " solid ").concat(componentTheme.borderColor)
    },
    categoriesContainer: {
      display: 'flex',
      flexFlow: 'row wrap',
      position: 'relative',
      paddingBottom: componentTheme.categoriesContainerPadding
    },
    categoryContainer: _defineProperty({
      flexBasis: '50%'
    }, mq, {
      flexBasis: '100%'
    }),
    categoryContainerWrapper: {
      paddingRight: componentTheme.categoryContainerWrapperPadding
    },
    categoryBody: {
      border: "".concat(componentTheme.borderWidth, " solid ").concat(componentTheme.borderColor)
    },
    categoryBodyDescriptionInput: {
      padding: componentTheme.categoryDescriptionInputPadding,
      backgroundColor: componentTheme.categoryDescriptionBackground
    },
    categoryBodyAnswers: {
      padding: componentTheme.categoryBodyAnswersPadding
    },
    itemContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingTop: componentTheme.itemContainerPadding
    },
    itemContainerBody: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: componentTheme.itemContainerBodyPadding
    },
    itemContainerActions: {
      display: 'flex'
    }
  };
};
export default generateStyle;